<div class="input-container">
  @if (label && labelType !== labelTypeOptions.PLACEHOLDER) { @if (labelType === labelTypeOptions.STATIC) {
  <div class="d-flex gap-1 align-items-center">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
    @if (inputLabelTooltipText?.length) {
    <finxone-platform-tooltip
      [content]="inputLabelTooltipText"
      [textStyleClass]="tooltipTextStyleClass"
      [borderRadiusClass]="tooltipBorderRadiusClass"
    ></finxone-platform-tooltip>
    }
  </div>
  } @else {
  <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  } }
  <div
    #inputElementWrapper
    class="input-wrapper position-relative"
    [class]="isVerifyButtonShown ? 'd-flex align-items-flex-end' : ''"
    [style]="{ gap: spaceBetweenItem() }"
  >
    <!-- Prefix Content -->
    <ng-content #prefixContent select="[prefix]"></ng-content>
    <!-- Custom Template or Default Input -->
    <ng-container
      *ngIf="customInputTemplate; else defaultInput"
      [ngTemplateOutlet]="customInputTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          value: value,
          control: control,
          onInput: onInputChange.bind(this),
          onBlur: onTouched.bind(this),
          onFocus: onTouched.bind(this),
        }
      }"
    ></ng-container>

    @if (isVerifyButtonShown) {
    <ng-container [ngTemplateOutlet]="defaultButtonTemplate"></ng-container>
    }

    <!-- Suffix Content -->
    <ng-content #suffixContent select="[suffix]"></ng-content>
  </div>

  <!-- Info  Template -->
  <ng-container *ngIf="infoText">
    <div [innerHTML]="infoText | safeHtml"></div>
  </ng-container>

  <div *ngIf="showErrors && control?.invalid && control?.touched" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
      <small class="typog-xs text-error">
        {{ getErrorMessageBasedOnKey(error) }}
      </small>
      }
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control?.errors
        }
      }"
    ></ng-container>
  </div>
</div>

<ng-template #defaultInput>
  <input
    #myInput
    hlmInput
    [type]="type"
    [formControl]="control"
    [id]="id"
    [name]="name"
    [value]="value"
    [attr.autocomplete]="disableAutocomplete ? 'new-password' : undefined"
    [attr.data-1p-ignore]="disableAutocomplete ? true : undefined"
    [attr.data-bwignore]="disableAutocomplete ? true : undefined"
    [attr.data-lpignore]="disableAutocomplete ? true : undefined"
    [attr.data-form-type]="disableAutocomplete ? 'other' : undefined"
    [placeholder]="
      labelType === labelTypeOptions.PLACEHOLDER
        ? label
        : labelType === labelTypeOptions.FLOATING
        ? ''
        : placeholder
    "
    [readonly]="readOnly"
    (input)="onInputChange($event)"
    (blur)="onTouched(); isInputOnFocus = false; blurEvent.emit()"
    (focus)="setFocusState(true)"
    [class]="class + ' ' + textStylingClass + ' ' + borderRadiusClass"
    [ngClass]="{
      'pl-7': hasPrefixContent,
      'pr-7': hasSuffixContent
    }"
    [attr.inputmode]="inputMode"
    [attr.maxlength]="maxLength ?? null"
    [numberMaxLength]="maxLength ?? null"
    [attr.mask]="mask || null"
  />
</ng-template>

<ng-template #defaultButtonTemplate>
  <finx-button
    [labeltext]="verifyButtonTextContent"
    class="d-flex pointer-events-none"
    [class]="isVerifyButtonGlobalStylingAllowed ? verifyButtonGlobalStylingClass : 'w-100'"
    [buttonStyle]="!isVerifyButtonGlobalStylingAllowed ? verifyButtonStyle : {}"
    [isAllowedGlobalStyling]="isVerifyButtonGlobalStylingAllowed"
    [style.height]="inputHeight + 'px'"
    (click)="onClickButton()"
    [type]="buttonType"
  ></finx-button>
</ng-template>

<ng-template #labelTemplate>
  <label
    [class.labelActive]="isInputOnFocus"
    [class.floatingLabelWithValue]="
      control?.value !== null && control?.value !== '' && labelType === labelTypeOptions.FLOATING
    "
    [class.floatingLabel]="labelType === labelTypeOptions.FLOATING"
    [style.margin-left]="
      inputFieldConfig?.currencyFormat === 'symbol' &&
      (labelType === labelTypeOptions.FLOATING || labelType === labelTypeOptions.PLACEHOLDER)
        ? '1rem'
        : '0'
    "
    class="labelText labelIdle labelConfig"
    [for]="name"
    (click)="handleLabelClick()"
    >{{ label }}</label
  >
</ng-template>
